<template>
    <section class="question">
        <question-tag
            :correctRate="question.correctRate"
            :avgSolveTime="question.avgSolveTime"
            :level="paperLevel"
        ></question-tag>

        <!-- {{solveTime}}
        
        {{setedAnswer}} -->

        <div class="pda-default">
            <div v-if="groupQuestionCount === 1">
                <div class="t-subtitle5">
                    {{ question.contents.text }}
                </div>
                <div class="mgt-16 independent-img-video-bd-radius" v-if="question.contents.image">
                    <img :src="question.contents.image" alt="">
                </div>
                <div class="question-choices mgt-16">
                    <!--<div class="t-body3 t-color-signGray">
                        {{$t('1257')}}
                         Write an essay -->
                    </div>
                    <div class="mdc-text-field mdc-text-field--textarea mdc-text-field--fullwidth" :id="`answerEl${question.id}`">
                        <div class="mdc-text-field-character-counter"></div>
                        <textarea @keyup="essayAnswer" id="textarea" class="mdc-text-field__input" rows="5"
                            v-model="text" :maxlength="question.essay.maxAmount"
                        ></textarea>
                        <div class="mdc-notched-outline">
                            <div class="mdc-notched-outline__leading"></div>
                            <div class="mdc-notched-outline__notch">
                                
                            </div>
                            <div class="mdc-notched-outline__trailing"></div>
                        </div>
                    </div>
                    <div v-if="checkAnswerValidate() && text" class="t-helper">
                        {{$t('1261', {str: question.essay.minAmount})}}
                    </div>
                </div> 
                
                
            

            <div class="group mgb-30" v-else>
                <div class="bottom-card1">
                    <div class="mdc-card mdc-elevation--z2 bottom-card1-1 bg-documentGray"></div>
                </div>
                <div class="bottom-card2">
                    <div class="mdc-card mdc-elevation--z1 bottom-card2-1 bg-documentGray"></div>
                </div>
                
                <div class="t-subtitle5">
                    {{groupQuestionTitle}}
                </div>

                <div class="mdc-card mdc-elevation--z3 pda-default mgt-16 bg-documentGray">
                    <div class="t-headline14">
                        {{ question.contents.text }}
                    </div>
                    <div class="mgt-16 independent-img-video-bd-radius" v-if="question.contents.image">
                        <img :src="question.contents.image" alt="">
                    </div>
                    <div class="question-choices mgt-16">
                        <div class="t-body3 t-color-signGray">
                            {{$t('1257')}}
                            <!-- Write an essay -->
                        </div>
                        <div class="mdc-text-field mdc-text-field--textarea mdc-text-field--fullwidth" :id="`answerEl${question.id}`">
                            <div class="mdc-text-field-character-counter"></div>
                            <textarea @keyup="essayAnswer" id="textarea" class="mdc-text-field__input" rows="5"
                                v-model="text" :maxlength="question.essay.maxAmount"
                            ></textarea>
                            <div class="mdc-notched-outline">
                                <div class="mdc-notched-outline__leading"></div>
                                <div class="mdc-notched-outline__notch">
                                    
                                </div>
                                <div class="mdc-notched-outline__trailing"></div>
                            </div>
                        </div>
                        <div v-if="checkAnswerValidate() && text" class="t-helper">
                            {{$t('1261', {str: question.essay.minAmount})}}
                        </div>
                    </div> 
                </div>

            </div>
            

            <div class="h-1"></div>
            <!-- {{question.essay.tabooWordList}} -->
            <question-tip v-if="question.tip" :tip="question.tip"/>

        </div>
    </section>
</template>

<script>
/**
 * 에세이 문항 컴포넌트(essay type question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import {questionMixin} from '@/mixins/question.js'
export default {
    props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'currentQuestionCheckStatus', 'setedAnswer', 'paperLevel'],
    data() {
        return {
            text: '',
            isSolve: false,
            textField: null
            
        }
    },
    components: {
        'question-tag': QuestionTag,
        'question-tip': QuestionTip,
    },

    mixins: [questionMixin],

    mounted() {
        this.text = this.setedAnswer.text
        this.isSolve = this.setedAnswer.isSolve
        this.solveTime = this.setedAnswer.solveTime || 0
        this.textField = new MDCTextField(document.querySelector(`#answerEl${this.question.id}`))        
        this.textField.value = this.text            
        this.startTimer()
    },
    watch: {
        // Set the answer when entering the answer
        text: function(value) {
            //this.setAnswer()
            //this.checkIsChecked()
        },
        // currentQuestionCheckStatus에 따라 타이머 동작(currentQuestionCheckStatus timer action)
        currentQuestionCheckStatus: function(value) {
            if (!value) {
                this.startTimer()
            }else {
                this.clearTimer()
                // this.setAnswer()
            }
        }
    },

    methods: {
        essayAnswer() {
            this.setAnswer()
        },
        //답안 유효성 체크(validation check answer)
        checkAnswerValidate() {
            let tabooWordValidate = _.some(this.question.essay.tabooWordList, (word) => {
                return _.includes(this.text, word)
            })

            let lengthValidate = this.question.essay.minAmount > this.text.length ? true : false

            return tabooWordValidate || lengthValidate
        },

        //답안정보 설정 및 부모 컴포넌트에 전달(Answer information setting and delivery to parent component)
        setAnswer() {

            // console.log(this.text.length);
            
            if (this.text && !this.checkAnswerValidate()) {
                this.isSolve = true
            } else {
                this.isSolve = false
            }

            let params = this.setParam()
            console.log('params', params)
            this.checkIsChecked()
            this.$emit('setAnswers', params)
            
        },

        checkIsChecked() {
            let params = this.setParam()
            this.$emit('checkIsCheckeds',params)
        },

        // 파라미터 설정(set parameter)
        setParam() {
            let params = {
                questionId: this.question.id,
                text: this.text,
                selected: [],
                texts: [],
                startDate: this.startDate,
                solveTime: this.solveTime,
                isSolve: this.isSolve
            }

            return params
        },

        
    }
}
</script>
